<template>
  <div ref="mediaInsertionInvoiceListInfoSectionContainer">
    <fieldset class="table-dynamic bs3-row-reset">
      <legend class="panel-section bs3-margin-bottom-reset">
        <i class="fa-light fa-file-invoice"></i> {{ 'dictionary.invoice.plural'| i18nText(pDictionary) }}
        <a v-if="newInvoiceButtonVisible" :href="pUrls['createInvoice'] + '?dataForm.data.mediaInsertionRef.id=' + pData.mediaInsertionRef.id + '&src=' + pSrc + '&srcId=' + pSrcId"
           :class="[{'disabled': !pData.allowedTo['CREATE_INVOICE']}, 'btn btn-default btn-sm bs3-margin-left ajax-support show-waiting']"
           data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-plus"></i>
          {{ pDictionary['dictionary.invoice.add'] }}</a>

        <div class="right">
          <span class="label label-info">{{ 'dictionary.invoice.frequency.' + pData.invoiceFrequency | i18nText(pDictionary) }}</span>
        </div>
      </legend>
      <div class="bs3-padding5 content-scrollable">
        <div v-if="!pData.invoices.length" class="emptyOrNull">
          {{'dictionary.general.none'| i18nText(pDictionary) }}
        </div>
        <table v-else class="table table-sm table-hover bs3-vertical-center bs3-margin-bottom-reset">
          <thead>
          <tr>
            <th v-if="actionsColumnsVisible" class="minWidthCell"></th>
            <th colspan="3" class="text-center">{{ 'dictionary.invoice.period' | i18nText(pDictionary) }}</th>
            <th class="text-center minWidthCell">{{ 'dictionary.invoice.status.short' | i18nText(pDictionary) }}</th>
            <th class="text-center minWidthCell">{{ 'dictionary.invoice.date.short' | i18nText(pDictionary) }}</th>
            <th class="text-nowrap">{{ 'dictionary.invoice.reference' | i18nText(pDictionary) }}</th>
            <th class="text-right minWidthCell">{{ 'dictionary.media.cost.planned' | i18nText(pDictionary) }}</th>
            <th class="text-right minWidthCell">{{ 'dictionary.media.cost.actual' | i18nText(pDictionary) }}</th>
            <th class="text-right minWidthCell">{{ 'dictionary.media.cost.invoiced' | i18nText(pDictionary) }}</th>
            <th v-if="pData.commissionEnabled" class="text-right minWidthCell">{{ 'dictionary.media.cost.commission.short' | i18nText(pDictionary) }}</th>
          </tr>
          </thead>
          <tbody id="invoiceListInfoList">
          <tr class="bottom-separator-ccc" v-if="expectedInvoicesHeaderVisible">
            <td :colspan="nbOfCols">
              <h5 class="bs3-margin-bottom-reset"><i class="fa-light fa-square-check"></i> {{'dictionary.invoice.expected' | i18nText(pDictionary)}}</h5>
            </td>
          </tr>
          <media-insertion-invoice-list-info-section-table-row
              v-for="invoice in expectedInvoices" :key="invoice.id"
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-urls="pUrls"
              :p-src="pSrc"
              :p-src-id="pSrcId"
              :p-currency-ref="pData.currencyRef"
              :p-invoice="invoice"
              :p-commission-enabled="pData.commissionEnabled"
              :p-form-display="pFormDisplay">
          </media-insertion-invoice-list-info-section-table-row>
          <tr class="bottom-separator-ccc" v-if="unexpectedInvoicesHeaderVisible">
            <td :colspan="nbOfCols">
              <h5 class="bs3-margin-bottom-reset"><i class="fa-light fa-square-exclamation"></i> {{'dictionary.invoice.unexpected' | i18nText(pDictionary)}}</h5>
            </td>
          </tr>
          <media-insertion-invoice-list-info-section-table-row
              v-for="invoice in unexpectedInvoices" :key="invoice.id"
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-urls="pUrls"
              :p-src="pSrc"
              :p-src-id="pSrcId"
              :p-currency-ref="pData.currencyRef"
              :p-invoice="invoice"
              :p-commission-enabled="pData.commissionEnabled"
              :p-form-display="pFormDisplay">
          </media-insertion-invoice-list-info-section-table-row>
          </tbody>
          <tfoot>
            <tr class="total">
              <td :colspan="nbOfColsFoot">{{ 'dictionary.invoice.count' | i18nText(pDictionary) | i18nparams(0, pData.invoices.length) }}</td>
              <td class="text-right text-nowrap text-muted">{{ pData.totalPlanned | money(pCurrencies, pData.currencyRef.id) | emptyToDash }}</td>
                <td class="text-right text-nowrap">{{ pData.totalActual | money(pCurrencies, pData.currencyRef.id) | emptyToDash }}</td>
              <td class="text-right text-nowrap">{{ pData.totalInvoiced | money(pCurrencies, pData.currencyRef.id) | emptyToDash }}</td>
              <td v-if="pData.commissionEnabled" class="text-right text-nowrap">{{ pData.totalCommission | money(pCurrencies, pData.currencyRef.id) | emptyToDash }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </fieldset>
  </div>
</template>

<script>

import MediaInsertionInvoiceListInfoSectionTableRow
  from "@/components/modules/planning-module/media-insertion/invoice-list-info/MediaInsertionInvoiceListInfoSectionTableRow";
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MediaInsertionInvoiceListInfoSection",
  components: {
    MediaInsertionInvoiceListInfoSectionTableRow
  },
  mixins: [BaseMixin, FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pSrc: String,
    pSrcId: String,
    pData: Object,  /* ca.ngenius.mediaplan.api.data.mediainsertion.MediaInsertionInvoiceListInfoData */
    pFormDisplay: Boolean
  },
  data: function () {
    return {
    }
  },
  computed: {
    newInvoiceButtonVisible: function() {
      return !this.pFormDisplay;
    },
    actionsColumnsVisible: function() {
      return !this.pFormDisplay;
    },
    nbOfCols: function() {
      let nbOfCols = 11;
      if(!this.pData.commissionEnabled) {
        nbOfCols--;
      }
      if(!this.actionsColumnsVisible) {
        nbOfCols--;
      }
      return nbOfCols;
    },
    nbOfColsFoot: function() {
      let nbOfColsFoot = 7;
      if(!this.actionsColumnsVisible) {
        nbOfColsFoot--;
      }
      return nbOfColsFoot;
    },
    expectedInvoices: function() {
      return this.pData.invoices.filter(i => i.expected === true);
    },
    unexpectedInvoices: function() {
      return this.pData.invoices.filter(i => i.expected === false);
    },
    expectedInvoicesHeaderVisible: function() {
      return this.expectedInvoices.length > 0 && this.unexpectedInvoices.length > 0;
    },
    unexpectedInvoicesHeaderVisible: function() {
      return this.unexpectedInvoices.length > 0;
    }
  },
  mounted: function () {
    let _component = this;
    _component.$nextTick(function () {
      let $mediaInsertionInvoiceListInfoSectionContainer = $(this.$refs.mediaInsertionInvoiceListInfoSectionContainer);
      $mediaInsertionInvoiceListInfoSectionContainer.find('[data-toggle="tooltip-inline"]').tooltip({sanitize: false});
    });
  },
  destroyed: function () {
    let $mediaInsertionInvoiceListInfoSectionContainer = $(this.$refs.mediaInsertionInvoiceListInfoSectionContainer);
    $mediaInsertionInvoiceListInfoSectionContainer.find('[data-toggle="tooltip-inline"]').tooltip('destroy');
  }
}
</script>

<style scoped>

</style>